import { Injectable } from '@angular/core';
import { GeoZoneDto } from 'app/models/region-map-editor/map-editor';
import { ApiHttp } from 'app/providers';
import { MessageService } from 'primeng/api';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class GeoZoneService {

	private geoZone$ = new BehaviorSubject<any>({});
	selectedGeoZone$ = this.geoZone$.asObservable();

	constructor(
		private apiHttp: ApiHttp) {
	}

	public getGeoZones(data: any, messageService: MessageService): Promise<any> {
		return this.apiHttp.post('api/GeoZone/GetGeoZones', data, messageService);
	}

	public getGeoZoneByName(data: GeoZoneDto, messageService: MessageService): Promise<any> {
		return this.apiHttp.post('api/GeoZone/GetGeoZoneByName', data, messageService);
	}

	public getGeoZoneExitPoint(data: any, messageService: MessageService): Promise<any> {
		return this.apiHttp.post('api/GeoZone/GetGeoZoneExitpoint', data, messageService);
	}

	setGeoZone(product: any) {
		this.geoZone$.next(product);
	}
}
